import React, {useState, useEffect} from 'react';
//Material-UI
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Rating from '@material-ui/lab/Rating';
import Divider from '@material-ui/core/Divider';
//GraphQL
import gql from 'graphql-tag';
import {useMutation} from '@apollo/react-hooks';
//DS
import {validacion} from 'lib.common';
const {esVarNullUndef} = validacion;

const useStyles = makeStyles(theme => ({
   root: {
      display: 'flex'
   },
   card: {
      // display: 'flex',
      padding: theme.spacing(2),
      borderRadius: 16
   },
   details: {
      display: 'flex',
      flexDirection: 'column'
   },
   content: {
      flex: '0 0 auto'
   },
   cover: {
      width: 151
   },
   controls: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: theme.spacing(1),
      paddingBottom: theme.spacing(1)
   },
   playIcon: {
      height: 38,
      width: 38
   },
   rating: {
      verticalAlign: 'text-top'
   },
   small: {
      width: theme.spacing(3),
      height: theme.spacing(3)
   }
}));

const CardDetalle = props => {
   const classes = useStyles();
   const dummyQuery = gql`
      mutation Error($codigo: String!) {
         error(codigo: $codigo)
      }
   `;
   const updateTicketDetalle = `mutation ActualizarTicketDetalle($ticketDetalle:String!, $valorizacion:Int){
    actualizarTicketDetalle(codigo:$ticketDetalle,valorizacion:$valorizacion){    
      valorizacion    
    }  
  }`;
   const queryActualizar = updateTicketDetalle ? gql(updateTicketDetalle) : dummyQuery;

   /**
    * Estados
    */
   const [ticketDetalle, setTicketDetalle] = useState(props.ticketDetalle);
   const [valorizacion, setValorizacion] = useState(ticketDetalle.valorizacion);
   const [values, setValues] = useState({
      ticketDetalle: ticketDetalle.codigo,
      valorizacion: 0
   });
   const asesor = props.ticketDetalle.asesor;
   const cliente = props.ticketDetalle.cliente;
   const [procesar, {error: errorP, data: dataP}] = useMutation(
      /*allowUpdate ? queryActualizar :*/ queryActualizar
   );
   /**
    * Funciones
    */

   const crearDenominacion = values => {
      let nombre = '';
      values.map(value => {
         if (value !== null) nombre += ` ${value} `;
      });
      return nombre;
   };
   const emisorMensaje = () => {
      let emisor = '';
      if (asesor !== null) {
         let values = [asesor.nombre, asesor.apPaterno, asesor.apMaterno];
         emisor = crearDenominacion(values);
      } else {
         if (cliente !== null) {
            let values = [cliente.nombre, cliente.apPaterno, cliente.apMaterno];
            emisor = crearDenominacion(values);
         }
      }

      return (
         <Typography component="p" color="textPrimary" variant="body1">
            {emisor}
         </Typography>
      );
   };

   const genParamActualizar = () => {
      return {
         ticketDetalle: values.ticketDetalle,
         valorizacion: valorizacion
      };
   };
   const esInputOk = async => {
      let resultado = {
         msg: '',
         ok: true
      };
      return resultado;
   };
   const procesarGrabar = async () => {
      //procesarAntesGrabar();

      let input = esInputOk();
      if (input.ok) {
         let param = {};
         await Object.assign(param, await genParamActualizar());
         procesar({variables: param});
      } else {
         // handleOpen(input.msg);
      }
   };
   const procesarDespuesGrabar = async () => {
      setValues({...values, ['descripcion']: ''});
      //props.setProcesarOK(true);
   };
   /**
    * Efectos procesar
    */
   useEffect(() => {
      if (!esVarNullUndef(dataP)) {
         const dataAux = dataP[Object.keys(dataP)[0]];
         if (dataAux != null /*&& dataAux.length > 0*/) {
            //handleOpen(esOkDefault.mensaje);
            procesarDespuesGrabar();
         }
      }
   }, [dataP]);
   /**
    * Efectos Errores
    */
   useEffect(() => {
      let eMsg = '';

      if (!esVarNullUndef(errorP)) {
         eMsg = eMsg + JSON.stringify(errorP);
      }
      if (eMsg !== '') {
         //handleOpen(eMsg);
      }
   }, [errorP]);

   /**
    * Efectos
    */

   useEffect(() => {
      // setValues({...values, ["valorizacion"]: valorizacion});
      procesarGrabar();
   }, [valorizacion]);

   return (
      <Card className={classes.card} variant="outlined">
         <CardHeader
            avatar={
               <Avatar
                  aria-label="asesor"
                  src={'' /*ticketDetalle.asesorFoto*/}
                  className={classes.small}
               />
            }
            action={
               ticketDetalle.asesor !== null && (
                  <Rating
                     name={'rating'}
                     value={2}
                     className={classes.rating}
                     size={'small'}
                     value={valorizacion}
                     onChange={(event, newValue) => {
                        setValorizacion(newValue);
                     }}
                  />
               )
            }
            title={emisorMensaje()}
         />
         <Divider />
         <div className={classes.details}>
            <CardContent className={classes.content}>
               <Typography variant="body1" color="textSecondary" component="p">
                  {ticketDetalle.descripcion}
               </Typography>
            </CardContent>
            <Divider />
            <Typography component="p" color="textPrimary" variant="body1">
               Adjuntos
            </Typography>
         </div>
         {/*ticketDetalle.archivo.map((archivo, id) => (
          <div>
            <Archivo  archivo={ticketDetalle.archivo} />
            <Archivo  archivo={archivo} />
          </div>
        ))*/}
      </Card>
   );
};

export default CardDetalle;
